import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { formatDateForTimeZone } from 'src/app/core/base/base';

@Pipe({
    name: 'datePerZoneTransform'
})

export class DatePerZonePipe implements PipeTransform {

    transform(value: any,dateFormat: string): any {
        if (!value) return null;

        let date = new Date(value);
    
        // Ensure the date is treated as UTC
        const utcDate = new Date(Date.UTC(
            date.getUTCFullYear(), 
            date.getUTCMonth(), 
            date.getUTCDate(), 
            date.getUTCHours(), 
            date.getUTCMinutes(), 
            date.getUTCSeconds(), 
            date.getUTCMilliseconds()
        ));
    
        // Format the date using the provided date format
        return formatDate(utcDate, dateFormat, 'en-US', '+0000');
    }
}


